import { useEffect, useState } from 'react';

import ProgressBar from 'react-bootstrap/ProgressBar';

import { Container } from './styles';

export function LinearLoader() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let subs = true;
    if (progress <= 100) {
      if (progress === 0) {
        setTimeout(() => {
          if (subs) {
            setProgress((prevState) => prevState + 20);
          }
        }, 100);
      } else {
        setTimeout(() => {
          if (subs) {
            setProgress((prevState) => prevState + 20);
          }
        }, 500);
      }
    } else {
      setProgress(0);
    }
    return () => {
      subs = false;
    };
  }, [progress]);

  return (
    <Container>
      <ProgressBar now={progress} style={{ height: '4px' }} />
    </Container>
  );
}
